import type { ToolbarDensity } from '@amelio/ui-library';

/**
 * The toolbar every editor the module lets someone type in wears: smaller buttons, soft grey, less
 * space between them. Declared once so the whole module answers the question the same way, and so
 * changing that answer is one line.
 */
export const EDITOR_TOOLBAR_DENSITY: ToolbarDensity = 'compact';
